import { CSSProperties, FC } from 'react';
import SpinnerIcon from './SpinnerIcon';
import './_Spinner.sass';

interface ISpinnerProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const Spinner: FC<ISpinnerProps> = ({
  size = 48,
  color = 'var(--neutral_12, #16181d)',
  className = '',
}) => {
  const style = {
    color,
    '--spinner-size': typeof size === 'number' ? `${size}px` : size,
  } as CSSProperties;

  return (
    <span className={`spinner ${className}`.trim()} style={style}>
      <SpinnerIcon size={size} />
    </span>
  );
};

export default Spinner;
